module.exports = __webpack_public_path__ + "img/credit-card.5752fcde.svg";